'use client';
import Typography from '@/components/shared/typography/typography.component';
import { ArrowDarkDown } from '../../../../public/Images';
import Image from 'next/image';

const FilterItemButton = ({
    text,
    buttonClicked,
}: {
    text: string;
    buttonClicked: (text: string) => void;
}) => {
    return (
        <button
            onClick={() => buttonClicked(text)}
            className={
                'flex items-center justify-between border-gray-300 w-max gap-3 px-3.5 py-2 rounded-lg border border-solid '
            }
        >
            <Typography
                variant="body2Medium"
                color="#344054"
                className={
                    "whitespace-nowrap w-['max-content'] font-semibold text-['0.875rem']"
                }
            >
                {text}
            </Typography>
            <Image
                width={ArrowDarkDown.width}
                height={ArrowDarkDown.height}
                src={ArrowDarkDown.src}
                alt=""
            />
        </button>
    );
};

export default FilterItemButton;
